import React, { Component } from "react";
import { Header, Form, Message, Segment } from "semantic-ui-react";

// import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";

class UpdateComponent extends Component {
  state = {
    projectName: "",
    projectDescription: "",
    projectTags: "",
    projectCompletionYear: "",
    success: false,
    error: false,
    errorMsg: ""
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  componentWillMount() {
    let project = this.props.data;
    this.setState({
      projectName: project.project_name,
      projectDescription: project.description,
      projectTags: project.tags,
      projectCompletionYear: project.completion_year
    });
  }

  handleSubmit = () =>{
    const {
        projectName,
        projectDescription,
        projectTags,
        projectCompletionYear
      } = this.state;

      if (projectCompletionYear.length !== 4 || isNaN(projectCompletionYear)) {
        this.setState({ errorMsg: "Year should be of 4 numbers!" });
        this.setState({ error: true });
        return;
      }
  
      if (projectName.length >= 120) {
        this.setState({ errorMsg: "Project Name should be of 100 characters" });
        this.setState({ error: true });
        return;
      }

      fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.updateProject, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("dat")
        },
        body: JSON.stringify({
          project: {
            id: this.props.data.id,
            project_name: projectName,
            description: projectDescription,
            tags: projectTags,
            completion_year: projectCompletionYear
          }
        })
      })
        .then(resp => resp.json())
        .then(data => {
          if (!data["success"]) {
            console.log(data);
            this.setState({ error: true, errorMsg: data.error });
          } else {
            console.log(data);
            this.setState({ success: true });
            console.log("Updated!");
          }
        });
  }

  render() {
    let {
      projectName,
      projectDescription,
      projectTags,
      projectCompletionYear
    } = this.state;

    return (
      <Segment inverted>
          <Header inverted>ProjectId: {this.props.data.id}</Header>
      <Form
        size="medium"
        onSubmit={this.handleSubmit}
        error={this.state.error}
        inverted
      >
        <Form.Input
          fluid
          name="projectName"
          label="Project Name"
          icon="file text"
          iconPosition="left"
          placeholder="Name of your Project"
          value={projectName}
          onChange={this.handleChange}
          required={true}
        />
        <Form.TextArea
          // fluid
          name="projectDescription"
          label="Project Description"
          // icon="file text outline"
          // iconPosition="left"
          placeholder="Write about your Project"
          value={projectDescription}
          onChange={this.handleChange}
          required={true}
        />
        <Form.TextArea
          fluid
          name="projectTags"
          label="Tags associated with your Project (seperate by comma)"
          icon="tags"
          iconPosition="left"
          placeholder="Tags associated with your Project, seperate by comma"
          value={projectTags}
          onChange={this.handleChange}
          required={true}
        />
        <Form.Input
          fluid
          name="projectCompletionYear"
          label="Year of Completion"
          icon="calendar"
          iconPosition="left"
          placeholder="yyyy"
          value={projectCompletionYear}
          onChange={this.handleChange}
          required={true}
        />
        <Message positive success={!this.state.success}>
            <Message.Content>
                Updated!
            </Message.Content>
        </Message>
        <Message error={!this.state.error}>
          <Message.Content>
            {this.state.errorMsg + ", Reload and Retry Again..."}
          </Message.Content>
        </Message>
        <Form.Button
          color="grey"
          size="large"
          type="submit"
          disabled={this.state.error || this.state.success}
        >
          Update
        </Form.Button>
      </Form>
      </Segment>
    );
  }
}

class ProjectUpdateForm extends Component {
    state={projects: []}
  componentWillMount() {
    let memberId = localStorage.getItem("id");
    let projectsToBeRendered = [];
    fetch(
      LINKS.SERVER_BASE_URL +
        LINKS.SERVER_ROUTES.getProjectsByMemberId +
        memberId
    )
      .then(resp => resp.json())
      .then(data => {
        data['projects'].forEach((each, index) => {
          projectsToBeRendered.push(
              <UpdateComponent key={each.id} data={each} />
          );
        });
        this.setState({projects: projectsToBeRendered})
      });
  }

  render() {
    return (
      <Segment style={{ marginBottom: "3em", marginTop: "3em" }} inverted>
          <Header as='h5'>You can update your projects here</Header>
          {this.state.projects}
      </Segment>
      

    );
  }
}

export default ProjectUpdateForm;
